
export default {
  name: 'schedule-filter',
  model: {
    prop: 'request',
    event: 'change',
  },
  props: {
    request: {
      type: Object,
      required: true,
    },
  },
};
